import { createAction, props } from '@ngrx/store';

import { Container } from 'app/shared/features/container-selector/models';

export const updateContainers = createAction(
    '[Container] Update Containers',
    props<{ containerList: Container[] }>(),
);
